import React, {memo} from 'react'
import TextField from '@material-ui/core/TextField';

const AppTextArea = memo(({id, name, label, value = '', required = false, block = true, disabled=false, helperText, onChange}) => {

    let style = {};

    if (block) {
        style.width = '100%'
    }

    return (
        <TextField
            required={required}
            value={value}
            onChange={onChange}
            id={id}
            name={name}
            label={label}
            style={style}
            disabled={disabled}
            rows="6"
            multiline
            inputProps={{
                maxLength: 400,
            }}
            helperText={helperText}
            variant="outlined"/>
    );

});
export default AppTextArea